<template>
  <v-card style="height: 700px; position: relative">
    <v-progress-circular
      indeterminate
      color="primary"
      size="50"
      style="
        position: absolute;
        top: 150px;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 1;
      "
      v-if="blockCreating"
    ></v-progress-circular>
    <v-card-text
      class="pa-0 ma-0"
      :style="{
        'pointer-events': blockCreating ? 'none' : 'inherit',
        opacity: blockCreating ? 0.2 : 1,
      }"
    >
      <v-tabs
        centered
        grow
        style="
          width: 100%;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          right: 0;
          border-bottom: 1px solid #ececec;
        "
      >
        <v-tab @click="selectedParentTab = 'ALL_BLOCKS'">All Blocks</v-tab>
        <v-tab @click="selectedParentTab = 'SAVED_BLOCKS'">
          <v-badge
            :content="savedBlocks.length == 0 ? '0' : savedBlocks.length"
            color="accent"
            >My Blocks</v-badge
          >
        </v-tab>
        <v-tab @click="selectedParentTab = 'UNIVERSAL_BLOCKS'">
          <v-badge
            :content="
              universalBlocks.length == 0 ? '0' : universalBlocks.length
            "
            color="accent"
            >Universal Blocks</v-badge
          >
        </v-tab>
      </v-tabs>
      <div
        v-if="selectedParentTab == 'ALL_BLOCKS'"
        style="padding-top: 48px; background-color: white; height: 100%"
      >
        <v-row>
          <div
            style="
              padding-top: 0px;
              position: absolute;
              width: 200px;
              left: 0px;
              top: 50px;
              bottom: 0;
              background-color: #efefef;
            "
          >
            <v-tabs vertical>
              <v-btn
                v-for="(group, name) in blockDefinitions"
                :key="name"
                @click="selectedTab = name"
                :color="selectedTab == name ? 'primary' : ''"
                text
                style="border-radius: 0px"
                :style="{
                  'background-color':
                    selectedTab == name ? '#cccccc' : '#efefef',
                }"
              >
                <span
                  @mouseenter="selectedTab = name"
                  style="
                    flex-grow: 1;
                    text-align: left;
                    text-transform: capitalize;
                    font-size: 18px;
                  "
                  >{{ name }}</span
                >
                <span>{{
                  group.blocks.filter((b) => isAppliablePages(b)).length
                }}</span>
              </v-btn>
            </v-tabs>
          </div>
          <div style="margin-left: 220px">
            <div>
              <div
                v-for="(group, name) in blockDefinitions"
                :key="name"
                class="block-definitions"
                style="margin: 5px"
              >
                <v-lazy v-if="selectedTab == name">
                  <div>
                    <div
                      v-for="block in group.blocks.filter((b) =>
                        isAppliablePages(b)
                      )"
                      :key="block.type"
                      @click="tryCreateBlock(block)"
                      class="block-definition"
                      :class="{ 'plan-upgrade-need': !canUseBlock(block) }"
                    >
                      <img
                        :src="block.preview"
                        style="width: 100%; height: 100%; max-width: 500px"
                        :class="{
                          'plan-upgrade-need-inside': !canUseBlock(block),
                        }"
                      />
                      <div class="block-type">
                        <v-chip class="mr-1">{{ block.name }}</v-chip>
                        <v-chip
                          v-for="plan in block.plans"
                          :key="plan"
                          class="mr-1"
                          color="primary"
                        >
                          <v-icon small>mdi-lock-outline</v-icon>
                          {{ plan }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </v-lazy>
              </div>
            </div>
          </div>
        </v-row>
      </div>
      <div
        v-if="selectedParentTab == 'SAVED_BLOCKS'"
        style="padding-top: 48px; background-color: white; height: 100%"
      >
        <v-alert dense text border="left" type="info" class="ma-2"
          >You can re-use your existing blocks in pages in order to prevent
          duplicate blocks.</v-alert
        >
        <v-alert
          dense
          text
          border="left"
          type="warning"
          class="ma-2"
          v-if="savedBlocks.length === 0"
        >
          You don't have any block saved. Select a block and go to
          <strong>Share</strong> tab
        </v-alert>
        <div class="your-block-definitions" style="margin: 5px">
          <div
            v-for="block in savedBlocks"
            :key="'ref-' + block.id"
            @click="tryReferenceBlock(block)"
            class="block-definition saved-blocks"
          >
            <v-chip color="primary">{{ block.createdInPage }}</v-chip>
            <v-icon>mdi-chevron-right</v-icon>
            <v-chip>{{ geBlockNameByBlockType(block.type) }}</v-chip>
          </div>
        </div>
      </div>
      <div
        v-if="selectedParentTab == 'UNIVERSAL_BLOCKS'"
        style="padding-top: 48px; background-color: white; height: 100%"
      >
        <v-alert dense text border="left" type="info" class="ma-2">
          You can re-use your existing blocks across your projects in order to
          prevent duplicate blocks and maintain same set of user interface
          easily.
        </v-alert>
        <PaidFeature :plans="['LITE', 'PREMIUM']">
          <v-alert
            dense
            text
            border="left"
            type="warning"
            class="ma-2"
            v-if="universalBlocks.length === 0"
          >
            You don't have any Universal Block saved. Select a block and go to
            <strong>Share</strong> tab
          </v-alert>
          <div class="your-block-definitions" style="margin: 5px">
            <div
              v-for="block in universalBlocks"
              :key="'ref-' + block.id"
              @click="tryReferenceBlock(block)"
              class="block-definition saved-blocks"
            >
              <v-chip>{{ block.createdInProject }}</v-chip>
              <v-icon>mdi-chevron-right</v-icon>
              <v-chip color="primary">{{ block.createdInPage }}</v-chip>
              <v-icon>mdi-chevron-right</v-icon>
              <v-chip>{{ geBlockNameByBlockType(block.type) }}</v-chip>
            </div>
          </div>
        </PaidFeature>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import projectMixin from "../project/project-mixin";
import PaidFeature from "../PaidFeature";

export default {
  props: ["order", "demo"],
  mixins: [projectMixin],
  components: { PaidFeature },
  computed: {
    ...mapState({
      blockDefinitions: (state) => state.blockDefinitions,
      savedBlocks: (state) => state.project.savedBlocks,
      universalBlocks: (state) => state.project.universalBlocks,
      selectedPage: (state) => state.project.selectedPage,
    }),
  },
  data() {
    return {
      selectedParentTab: "ALL_BLOCKS",
      selectedTab: "Headers",
      blockCreating: false,
    };
  },
  methods: {
    ...mapActions({
      createBlock: "project/createBlock",
      referenceBlock: "project/referenceBlock",
      getSavedBlocks: "project/getSavedBlocks",
      getUniversalBlocks: "project/getUniversalBlocks",
    }),
    async tryCreateBlock(block) {
      if (this.demo) {
        this.ALERT_SUCCESS("Blocks are demonstrated for demo purposes");
        return;
      }
      if (!this.canUseBlock(block)) {
        return;
      }
      this.blockCreating = true;
      block.order = "" + this.order;
      await this.createBlock(block);
      this.$emit("close");
      this.bus.$emit("block-created", block);
      this.blockCreating = false;
      this.broadcastBlockCreated(this.editingBlockId);
    },
    async tryReferenceBlock(block) {
      if (this.demo) {
        this.ALERT_SUCCESS("Blocks are demonstrated for demo purposes");
        return;
      }
      this.blockCreating = true;
      await this.referenceBlock({
        referencedBlockId: block.id,
        order: "" + this.order,
      });
      this.$emit("close");
      this.bus.$emit("block-created", block);
      this.blockCreating = false;
      this.broadcastBlockCreated(this.editingBlockId);
    },
    canUseBlock() {
      return true;
      // if (block.plans) {
      //   return block.plans.indexOf(this.user.plan) > -1;
      // }
      // return true;
    },
    isAppliablePages(block) {
      if (this.demo) {
        return 1;
      }
      return block.appliablePages.indexOf(this.selectedPage.type) > -1;
    },
  },
  created() {
    if (this.demo) {
      return;
    }
    this.getSavedBlocks();
    this.getUniversalBlocks();
  },
};
</script>

<style scoped>
.your-block-definitions {
  display: flex;
  flex-wrap: wrap;
}
.block-definition {
  width: 100%;
  max-height: 100%;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid #efefef;
  position: relative;
  transition: 200ms all;
  margin-bottom: 20px;
  min-height: 100px;
}
.block-definition:hover {
  border: 1px solid #292961;
  background-color: #f7f5f5;
}
.block-definition.plan-upgrade-need {
  cursor: not-allowed !important;
  pointer-events: none;
}
.plan-upgrade-need-inside {
  background-color: #efefef;
  opacity: 0.5;
}
.block-type {
  position: absolute;
  top: 10px;
  left: 10px;
  font-style: italic;
  color: #464343;
  font-size: 12px;
}
.block-definition.saved-blocks {
  width: 50%;
}
</style>